"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PmsStatusPhoto = exports.CHANNEL_APP_SCHEME = void 0;
exports.fetchDownloadImage = fetchDownloadImage;
exports.fetchGetEnableChannel = fetchGetEnableChannel;
exports.fetchShowDiverseShare = fetchShowDiverseShare;
exports.fetchSystemShare = fetchSystemShare;
exports.checkSaveImagePms = checkSaveImagePms;
exports.fetchProfitImage = fetchProfitImage;
const tslib_1 = require("tslib");
const tool_nn_1 = tslib_1.__importDefault(require("@futuweb/tool-nn"));
const nnq_1 = tslib_1.__importDefault(require("@futuweb/tool-nn/dist/nnq"));
const base64_image_1 = require("./base64-image");
const constants_1 = require("./constants");
const log_1 = tslib_1.__importDefault(require("./log"));
const type_1 = require("./type");
const SUCCESS_CODE = 0;
async function bridgeCallHandler(name, params) {
    var _a;
    log_1.default.info('bridgeCallHandler request', {
        name,
        params
    });
    if (!((_a = nnq_1.default === null || nnq_1.default === void 0 ? void 0 : nnq_1.default.bridge) === null || _a === void 0 ? void 0 : _a.callHandler)) {
        throw new Error('jsBridge初始化失败');
    }
    return new Promise((resolve, reject) => {
        var _a;
        try {
            ((_a = nnq_1.default === null || nnq_1.default === void 0 ? void 0 : nnq_1.default.bridge) === null || _a === void 0 ? void 0 : _a.callHandler)(name, params, (responseData) => {
                log_1.default.info('bridgeCallHandler response', {
                    name,
                    params,
                    responseData
                });
                if (typeof responseData === 'string') {
                    responseData = JSON.parse(responseData);
                }
                resolve(responseData);
            });
        }
        catch (error) {
            log_1.default.error('bridgeCallHandler catch', {
                name,
                params,
                error
            });
            reject(error);
        }
    });
}
/**
 * 请求下载图片协议
 * http://fservice.server.com/repository/project/1208750/proto-space/4691/main/-/setSaveImg.md?method_branch=main
 * @param {object} params
 * @param {string | string[]} params.image
 */
async function fetchDownloadImage(params) {
    const { images } = params;
    const base64Image = (0, base64_image_1.getBase64Image)();
    const { urls, base64Ids } = base64Image.classifyImages(images);
    const res = await bridgeCallHandler('setSaveImg', {
        version: 1,
        // 图片保存
        save_images: {
            // url类型
            images_url: urls,
            // base64类型
            images_base64: base64Ids
        },
        // 获取图片Base64的JS方法名称
        fetch_image_js_func: base64_image_1.base64ImageKeys.fetchImageBase64ByID
    });
    if (Number(res === null || res === void 0 ? void 0 : res.result) === SUCCESS_CODE) {
        return res;
    }
    throw res;
}
/**
 * 获取可访问app
 * @param {object} params
 * @param {string | string[]} params.channels
 */
async function fetchGetEnableChannel({ channels }) {
    return new Promise((resolve, reject) => {
        try {
            log_1.default.info('getThirdPartyAppShareSupport', {
                channels
            });
            nnq_1.default.getThirdPartyAppShareSupport(channels, (res) => {
                var _a;
                log_1.default.info('getThirdPartyAppShareSupport', {
                    res
                });
                if (typeof res === 'string') {
                    res = JSON.parse(res);
                }
                if (Number(res.code) === SUCCESS_CODE || ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.length)) {
                    // code = 1时 也会返回已判断的data
                    // 所以可直接根据data判断
                    const apps = res.data.filter((item) => item.share_enable).map((item) => item.app);
                    resolve(apps);
                }
                else {
                    reject(res);
                }
            });
        }
        catch (error) {
            log_1.default.info('getThirdPartyAppShareSupport catch', {
                error
            });
            reject(error);
        }
    });
}
var ShowType;
(function (ShowType) {
    // 1: 多图单选  2: 多图多选  3: 单图单选（快照分享）  4: 结构化数据
    // 5: 快速分享 快速分享可以理解为只支持一个渠道的分享，因此需要快速分享只需把showType设为5，enable_channel字段指定具体的**一个**渠道
    // 6: 同时分享图片和结构化数据,默认展示结构化数据 7: 同时分享图片和结构化数据,默认展示图片
    ShowType[ShowType["QuickShare"] = 5] = "QuickShare";
    ShowType[ShowType["ImageShare"] = 8] = "ImageShare";
})(ShowType || (ShowType = {}));
const CHANNEL_ID_MAP = {
    [type_1.Channel.FACEBOOK]: 0x80,
    [type_1.Channel.TWITTER]: 0x0100,
    [type_1.Channel.INSTAGRAM]: 0x08000,
    [type_1.Channel.TELEGRAM]: 0x80000,
    [type_1.Channel.XIAOHONGSHU]: 0x100000,
    [type_1.Channel.REDDIT]: 0x200000,
    [type_1.Channel.SYSTEM]: 0x2000,
    [type_1.Channel.WECHAT]: 0x08,
    [type_1.Channel.WECHAT_MOMENTS]: 0x10
};
// 跳转到渠道对应app
exports.CHANNEL_APP_SCHEME = {
    [type_1.Channel.FACEBOOK]: 'fb://',
    [type_1.Channel.TWITTER]: 'twitter://',
    [type_1.Channel.INSTAGRAM]: 'instagram://',
    [type_1.Channel.TELEGRAM]: 'tg://',
    [type_1.Channel.XIAOHONGSHU]: 'xhsdiscover://home',
    [type_1.Channel.REDDIT]: 'https://www.reddit.com/submit?title&url',
    [type_1.Channel.WECHAT]: 'weixin://',
    [type_1.Channel.WECHAT_MOMENTS]: 'weixin://'
};
/**
 * 唤起多类分享功能
 */
async function fetchShowDiverseShare(shareData) {
    const base64Image = (0, base64_image_1.getBase64Image)();
    const { urls, base64Ids } = base64Image.classifyImages([shareData.image]);
    const params = {
        show_type: ShowType.ImageShare,
        enable: CHANNEL_ID_MAP[shareData.channel],
        share_image: {
            images: [
                {
                    img: base64Ids[0] || urls[0],
                    description: shareData.text,
                    ext: {
                        // 解决ios下剪贴板被SDK覆盖问题
                        // 设置为true后，分享成功后会自动将分享内容复制到剪贴板
                        useClipboardToSendText: true
                    }
                }
            ],
            // 获取图片Base64的JS方法名称
            fetch_image_js_func: base64_image_1.base64ImageKeys.fetchImageBase64ByID
        }
    };
    const res = await bridgeCallHandler('setShowShare', params);
    // native分享下
    // result为0表示分享成功，为-1表示分享取消，其他为失败
    if ([0, -1].includes(Number(res.result))) {
        return res;
    }
    throw res;
}
/**
 * 系统分享
 */
async function fetchSystemShare(url) {
    return new Promise((resolve, reject) => {
        try {
            log_1.default.info('showDiverseShare', {
                url
            });
            nnq_1.default.showDiverseShare({
                show_type: ShowType.QuickShare,
                enable_channel: type_1.Channel.SYSTEM,
                share_data: {
                    common_model: {
                        url
                    }
                }
            }, (res) => {
                log_1.default.info('showDiverseShare', {
                    res
                });
                if (Number(res.result) === SUCCESS_CODE) {
                    resolve(res);
                }
                else {
                    reject(res);
                }
            }, (error) => {
                log_1.default.error('showDiverseShare', {
                    error
                });
                reject(error);
            });
        }
        catch (error) {
            log_1.default.error('showDiverseShare catch', {
                error
            });
            reject(error);
        }
    });
}
// 权限状态类型
var PmsStatusType;
(function (PmsStatusType) {
    PmsStatusType[PmsStatusType["CAMERA"] = 1] = "CAMERA";
    PmsStatusType[PmsStatusType["PHOTO"] = 2] = "PHOTO";
    PmsStatusType[PmsStatusType["POS"] = 4] = "POS"; // 定位
})(PmsStatusType || (PmsStatusType = {}));
var PmsStatusPhoto;
(function (PmsStatusPhoto) {
    PmsStatusPhoto[PmsStatusPhoto["NONE"] = 0] = "NONE";
    PmsStatusPhoto[PmsStatusPhoto["ACCEPT"] = 1] = "ACCEPT";
    PmsStatusPhoto[PmsStatusPhoto["REJECT"] = 2] = "REJECT";
    PmsStatusPhoto[PmsStatusPhoto["UNKNOWN"] = -1] = "UNKNOWN"; // 未处理的枚举状态
})(PmsStatusPhoto || (exports.PmsStatusPhoto = PmsStatusPhoto = {}));
/**
 * 图片保存权限检查
 * @returns {boolean}
 */
async function checkSaveImagePms() {
    const params = {
        version: 1,
        type: PmsStatusType.PHOTO
    };
    const res = await bridgeCallHandler('getAuthorizationStatus', params);
    if (Number(res === null || res === void 0 ? void 0 : res.result) === SUCCESS_CODE) {
        return Number(res.photo);
    }
    throw res;
}
// 图片风格
const PROFIT_IMAGE_STYLE = {
    AUTO: 0, // 跟随本地用户设置
    IP: 1, // ip图片
    LOGO: 2 // logo图片
};
// 盈亏类型
const PROFIT_IMAGE_TYPE = {
    MONEY: 0, // 今日盈亏金额
    RATIO: 1 // 今日盈亏比例
};
const PROFIT_IMAGE_FILTER = {
    POSITIVE: 2, // 条件为正
    NEGATIVE: 1, // 条件为负
    ZERO: 0 // 条件为平
};
/**
 * 获取今日盈亏图分享图
 */
async function fetchProfitImage({ type }) {
    // 版本判断 小于指定版本不支持
    if (tool_nn_1.default.beforeThanAndroid(constants_1.FETCH_PROFIT_IMAGE_VERSION)) {
        return null;
    }
    if (tool_nn_1.default.beforeThanIOS(constants_1.FETCH_PROFIT_IMAGE_VERSION)) {
        return null;
    }
    let params = {
        image_style: PROFIT_IMAGE_STYLE.AUTO,
        profit_type: PROFIT_IMAGE_TYPE.MONEY,
        filter_condition: [
            // 筛选条件。客户端需要返回匹配到数组里的条件的image
            PROFIT_IMAGE_FILTER.POSITIVE
        ]
    };
    if (type === constants_1.IMAGE_TYPE.MONEY_IP) {
        params = Object.assign(Object.assign({}, params), { image_style: PROFIT_IMAGE_STYLE.IP, profit_type: PROFIT_IMAGE_TYPE.MONEY });
    }
    else if (type === constants_1.IMAGE_TYPE.MONEY_LOGO) {
        params = Object.assign(Object.assign({}, params), { image_style: PROFIT_IMAGE_STYLE.LOGO, profit_type: PROFIT_IMAGE_TYPE.MONEY });
    }
    else if (type === constants_1.IMAGE_TYPE.RATIO_IP) {
        params = Object.assign(Object.assign({}, params), { image_style: PROFIT_IMAGE_STYLE.IP, profit_type: PROFIT_IMAGE_TYPE.RATIO });
    }
    else if (type === constants_1.IMAGE_TYPE.RATIO_LOGO) {
        params = Object.assign(Object.assign({}, params), { image_style: PROFIT_IMAGE_STYLE.LOGO, profit_type: PROFIT_IMAGE_TYPE.RATIO });
    }
    const res = await bridgeCallHandler('getProfitShareImage', params);
    if (Number(res === null || res === void 0 ? void 0 : res.result) === SUCCESS_CODE && res.data.image_base64) {
        return `data:image/png;base64,${res.data.image_base64}`;
    }
    throw res;
}
//# sourceMappingURL=data:application/json;base64,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